// extracted by mini-css-extract-plugin
export default {"container":"AdminSFTP_container__N4J0X","header":"AdminSFTP_header__7p0j9"};